/* global axios */
import ApiClient from '../ApiClient';

class MaxChannel extends ApiClient {
  constructor() {
    super('max', { accountScoped: true });
  }

  getSession(inboxId) {
    return axios.get(`${this.baseUrl()}/max/session`, {
      params: { inbox_id: inboxId },
    });
  }

  createSession({ inboxId }) {
    return axios.post(`${this.baseUrl()}/max/session`, {
      inbox_id: inboxId,
    });
  }

  submitCode({ inboxId, code }) {
    return axios.post(`${this.baseUrl()}/max/session/code`, {
      inbox_id: inboxId,
      code,
    });
  }

  submitPassword({ inboxId, password }) {
    return axios.post(`${this.baseUrl()}/max/session/password`, {
      inbox_id: inboxId,
      password,
    });
  }

  deleteSession({ inboxId }) {
    return axios.delete(`${this.baseUrl()}/max/session`, {
      data: { inbox_id: inboxId },
    });
  }
}

export default new MaxChannel();
